import {productConfig} from '@/lib/productConfig';
import PausedBusiness from './PausedBusiness';
import CurrentAccess from './CurrentAccess';
import { useEffect } from "react";
import Lenis from "lenis";
import { useLocation } from "react-router-dom";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";

export default function Layout({ children }) {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin") || /^\/business\/(meetup-spot|dashboard|map|profile|profile-edit|events|offers|analytics|reviews|notifications|settings|date-time|verification|subscription|hours|email|privacy|language|help|promote|redeem|delete)(?:\/|$)/.test(pathname);

  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce || isAdmin) return;
    const lenis = new Lenis({ duration: 1.0, smoothWheel: true });
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, [pathname, isAdmin]);

  if(!productConfig.meetupSpotsEnabled && /^\/(business\/meetup-spot|meetup-spots|venue-signup)(\/|$)/.test(pathname))return <div className="min-h-screen bg-white"><Header/><CurrentAccess/><Footer/></div>;
  if(!productConfig.businessEnabled && /^\/business(?:\/|$)/.test(pathname))return <div className="min-h-screen bg-white"><PausedBusiness/></div>;
  if(!productConfig.peopleMonetizationEnabled && ['/pricing','/get-started'].includes(pathname))return <div className="min-h-screen bg-white"><Header/><CurrentAccess/><Footer/></div>;
  if (isAdmin) {
    return <div className="min-h-screen bg-lightbg">{children}</div>;
  }

  return (
    <div className="relative flex min-h-screen flex-col bg-white">
      <Header />
      <main className="site-main flex-1">{children}</main>
      <Footer />
    </div>
  );
}

